export default {

	init() {

		var container = document.querySelector('section.StationsMap');

		if( container && mapPoints ) {


			// -- Map -- //

				var zoomMax = 6.8;
				var zoomMin = 5.5;
				var zoomStep = (zoomMax - zoomMin) / 1600;

				var zoomValue = zoomMax;

				if( window.innerWidth < 1920 && window.innerWidth > 320 ) {

					zoomValue = zoomMin + (window.innerWidth * zoomStep);

					zoomValue = Math.round(zoomValue * 100) / 100;

				} else if( window.innerWidth <= 320 ) {

					zoomValue = zoomMin;

				}

				var mapOptions = {
			        zoom: zoomValue,
			        center: new google.maps.LatLng(52.065182, 19.089974), // Center of Poland
			        mapTypeControl: false,
			        streetViewControl: false,
			        fullscreenControl : false,
			        styles: [
					    {
					        "featureType": "administrative",
					        "elementType": "labels.text.fill",
					        "stylers": [
					            {
					                "color": "#0F0E11"
					            }
					        ]
					    },
					    {
					        "featureType": "landscape",
					        "elementType": "all",
					        "stylers": [
					            {
					                "color": "#F6F6F6"
					            }
					        ]
					    },
					    {
					        "featureType": "poi",
					        "elementType": "all",
					        "stylers": [
					            {
					                "visibility": "off"
					            }
					        ]
					    },
					    {
					        "featureType": "road",
					        "elementType": "all",
					        "stylers": [
					            {
					                "saturation": -100
					            },
					            {
					                "lightness": 45
					            }
					        ]
					    },
					    {
					        "featureType": "road.highway",
					        "elementType": "all",
					        "stylers": [
					            {
					                "visibility": "simplified"
					            }
					        ]
					    },
					    {
					        "featureType": "road.highway",
					        "elementType": "geometry",
					        "stylers": [
					            {
					                "visibility": "simplified"
					            }
					        ]
					    },
					    {
					        "featureType": "road.highway",
					        "elementType": "geometry.fill",
					        "stylers": [
					            {
					                "color": "#FFE100"
					            }
					        ]
					    },
					    {
					        "featureType": "road.arterial",
					        "elementType": "geometry.stroke",
					        "stylers": [
					            {
					                "color": "#FFE100"
					            }
					        ]
					    },
					    {
					        "featureType": "road.arterial",
					        "elementType": "labels.icon",
					        "stylers": [
					            {
					                "visibility": "off"
					            }
					        ]
					    },
					    {
					        "featureType": "road.local",
					        "elementType": "geometry.fill",
					        "stylers": [
					            {
					                "hue": "#FF0000"
					            },
					            {
					                "visibility": "off"
					            }
					        ]
					    },
					    {
					        "featureType": "road.local",
					        "elementType": "geometry.stroke",
					        "stylers": [
					            {
					                "visibility": "on"
					            },
					            {
					                "color": "#FFE100"
					            },
					            {
					                "weight": "0.52"
					            }
					        ]
					    },
					    {
					        "featureType": "transit",
					        "elementType": "all",
					        "stylers": [
					            {
					                "visibility": "off"
					            }
					        ]
					    },
					    {
					        "featureType": "water",
					        "elementType": "all",
					        "stylers": [
					            {
					                "color": "#ECECE8"
					            },
					            {
					                "visibility": "on"
					            }
					        ]
					    }
					]
			    };

			    var mapContainer = container.querySelector('.stationsMap__map');

			    var mapObject = new google.maps.Map(mapContainer, mapOptions);

			// -- END -- //



			// -- Map InfoWindow -- //

				var mapInfo = new google.maps.InfoWindow();
				var mapInfoBox = '';

				function renderMapInfoBox( name, address_1, address_2, stations, power, extra ) {

					mapInfoBox = '<div class="map__inforBox"><div class="box--size">';

					mapInfoBox += '<div class="box">'+
						'<p class="box__text"><strong>'+name+'</strong></p>'+
						'<p class="box__text">'+address_1+'</p>'+
						'<p class="box__text">'+address_2+'</p>'+
					'</div>';


					mapInfoBox += '<div class="box">'+
						'<p class="box__text">'+container.getAttribute('data-stations')+': <strong>'+stations+'</strong></p>'+
						'<p class="box__text">'+container.getAttribute('data-power')+': <strong>'+power+'</strong></p>'+
					'</div>';

					if( extra ) {

						mapInfoBox += '<div class="box"><p class="box__text--smaller">'+extra+'</p></div>';

					}

					mapInfoBox += '</div></div>';

					return mapInfoBox;

				}

			// -- END -- //



			// -- Markers -- // 

				var markerIconOptionsDefault = {
					url: window.location.origin+'/wp-content/themes/revnet/img/svg/map_marker.svg',
			    	scaledSize: new google.maps.Size(41, 63), // scaled size
				    origin: new google.maps.Point(0,0), // origin
				    anchor: new google.maps.Point(22, 60) // anchor
				};

				var markerIconOptionsClick = {
					url: window.location.origin+'/wp-content/themes/revnet/img/svg/map_marker--click.svg',
			    	scaledSize: new google.maps.Size(41, 63), // scaled size
				    origin: new google.maps.Point(0,0), // origin
				    anchor: new google.maps.Point(22, 60) // anchor
				};

				var markers = [];

				mapPoints.forEach( function( point, index ) {

					markers.push( 
						new google.maps.Marker({
					        position: new google.maps.LatLng(point.lati, point.long),
					        title: point.title,
					        map: mapObject,
					        icon : markerIconOptionsDefault,
					    })
				    );

				});

			// -- END -- //
		


			// -- Cluster -- //

				var clusterOptions = {
					gridSize: 30,
					averageCenter: true,
					styles: [
						{	
							anchor: [ 9, 0 ],
							url : window.location.origin+'/wp-content/themes/revnet/img/img/map_marker.png',
							width: 41,
							// height: 63,
							height: 69,
							textColor: '#FFFFFF',
							textSize: 22,
						}
					],
				}

		    	var cluster = new MarkerClusterer(mapObject, markers, clusterOptions);

            // -- END -- //



			// -- Actions -- //

				google.maps.event.addListener( mapObject, 'click', function() {

					markers.forEach( function(marker, index) {

						marker.setIcon( markerIconOptionsDefault );

					});

					mapInfo.close();

				});	

				markers.forEach( function(marker, index) {

					google.maps.event.addListener( marker, 'click', function(e) {

						e.stopPropagation;

						markers.forEach( function(marker2, index2) {

							marker2.setIcon( markerIconOptionsDefault );

						});

						marker.setIcon( markerIconOptionsClick );

						mapInfo.setContent( renderMapInfoBox( mapPoints[index]['title'], mapPoints[index]['address_1'], mapPoints[index]['address_2'], mapPoints[index]['stations'], mapPoints[index]['power'], mapPoints[index]['extra'] ) );
	      				mapInfo.open( mapObject , marker );

					});	

				});

			// -- END -- //


		}

	},
	finalize() {

	}

}